import request from '@/utils/request';

// 获取推荐图书列表
export function getRecommend(query) {
  return request({
    url: '/recommend/get_all',
    method: 'get',
    params: query
  })
}

// 获取读者借阅权限信息
export function getLoanRules(query) {
  return request({
    url: '/auth/rules/get_lend_num',
    method: 'get',
    params: query
  })
}

// 修改用户手机号
export function updatePhoneNumber(query){
  return request({
    url: '/user/updatePhoneNumber',
    method: 'post',
    params: query
  })
}

// 一站式PC端后端退出接口
export function logout(query){
  return request({
    url: '/sso/userLogout',
    method: 'post',
    data: query
  })
}

// 用户信息系统修改用户手机号
export function updatePhoneByUserManage(query){
  return request({
    url: '/user/updatePhoneByUserManage',
    method: 'post',
    params: query
  })
}

// 用户信息系统查看个人信息
export function getReaderInfoByUserManage(query){
  return request({
    url: '/user/getReaderInfoByUserManage',
    method: 'get',
    params: query
  })
}

// 提交已经反馈
export function formSubmitComment(query){
  return request({
    url: '/comment/insert',
    method: 'post',
    params: query
  })
}

// 手机号发送验证码6位数字
export function sendSMSByPhone(query){
  return request({
    url: '/user/sendSMSByPhone',
    method: 'post',
    params: query
  })
}

// 用户信息系统修改用户手机号且校验验证码
export function updatePhone(query){
  return request({
    url: '/user/updatePhone',
    method: 'post',
    params: query
  })
}

// 邮箱发送验证码6位数字
export function sendSMSByEmail(query){
  return request({
    url: '/user/sendSMSByEmail',
    method: 'post',
    params: query
  })
}

// 用户信息系统修改用户邮箱且校验验证码
export function updateEmail(query){
  return request({
    url: '/user/updateEmail',
    method: 'post',
    params: query
  })
}

// 服务点击量统计
export function clickAservice(query){
  return request({
    url: '/auth/click/aservice',
    method: 'post',
    params: query
  })
}

// 好书荐读获取推荐图书
export function getGbrrs(query){
  return request({
    url: '/gbrr/api/goodbook/sift/random/other?limit=5&appName=pc',
    method: 'get',
    params: query
  })
}
